import React, { useEffect, useRef, useState } from "react"
import axios from "axios"
import Header from "../../../components/user/common/Header"
import PageTitle from "../../../components/user/common/PageTitle"
import { useParams } from "react-router-dom"
import GoToTop from "../../../helpers/GoToTop"
import Footer from "../../../components/common/Footer"
import ServiceDetailsTabbing from "../../../components/user/common/services/ServiceDetailsTabbing"
import SpinnerLoader from "../../../components/common/SpinnerLoader"
import { BannerTopIframe } from "../../../components/common/BannerFrame"
import arrow_back from "../../../assets/icons/arrow-back.svg"
import { useHistory } from "react-router-dom"
import { Helmet } from "react-helmet"
import { isLogin } from "./../../../helpers/login"
import "bootstrap/dist/css/bootstrap.min.css"
import { Tooltip } from "bootstrap"
import { Badge } from "react-bootstrap"
import { Image } from "react-bootstrap"
import { FaStar, FaStarHalfAlt, FaRegStar } from "react-icons/fa"
import { Container, Row, Col, Card } from "react-bootstrap"
import { FaClipboardCheck, FaPhoneAlt, FaCogs, FaShippingFast } from "react-icons/fa"
import QuoteRequestButton from "../../../components/user/common/QuoteRequestButton"
import { toast } from 'react-toastify'
import LoginModal from "../../../components/common/modals/LoginModal"

const ServiceDetails = () => {
  const history = useHistory()
  const currentUser = isLogin()
  const { id } = useParams()
  const [commonServiceData, setCommonServiceData] = useState([])
  const [serviceCreator, setServiceCreator] = useState([])
  const [sellerId, setSellerId] = useState([])
  const [description, setDescription] = useState("")
  const [category, setCategory] = useState("")
  const [reviews, setReviews] = useState([])
  const [chargesPayStatus, setChargesPayStatus] = useState(null)
  const myRef = useRef(null)
  const reportRef = useRef(null)
  const [loading, setLoading] = useState(true)
  const [averageRating, setAverageRating] = useState(0)
  const [TotalReview, setTotalReview] = useState(0)
  const [scrollToReviews, setScrollToReviews] = useState(false)
  const [scheduledMeeting, setScheduledMeeting] = useState(false)
  const [showOrderPopup, setShowOrderPopup] = useState(false)
  const serviceId = id

  // Add state for auth info that updates when user logs in
  const [authInfo, setAuthInfo] = useState(() => JSON.parse(localStorage.getItem("authInfo")))
  const [userInfo, setUserInfo] = useState(() => JSON.parse(localStorage.getItem("userInfo")))

  sessionStorage.setItem("serviceId", serviceId)

  const [showLoginModal, setShowLoginModal] = useState(false);

  useEffect(() => {
    // When navigating between different services (same component, different :id),
    // we must refetch data. Otherwise you'll see stale details.
    setLoading(true)
    fetchApi()
    fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id])

  useEffect(() => {
    // Initialize tooltips after the component mounts
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
    tooltipTriggerList.forEach((tooltipTriggerEl) => new Tooltip(tooltipTriggerEl))
  }, [])

  // Add useEffect to listen for auth changes
  useEffect(() => {
    const handleStorageChange = () => {
      const newAuthInfo = JSON.parse(localStorage.getItem("authInfo"))
      const newUserInfo = JSON.parse(localStorage.getItem("userInfo"))
      setAuthInfo(newAuthInfo)
      setUserInfo(newUserInfo)
    }

    // Listen for storage changes
    window.addEventListener('storage', handleStorageChange)

    // Also check periodically in case of same-tab changes
    const interval = setInterval(() => {
      const currentAuthInfo = JSON.parse(localStorage.getItem("authInfo"))
      const currentUserInfo = JSON.parse(localStorage.getItem("userInfo"))

      if (JSON.stringify(currentAuthInfo) !== JSON.stringify(authInfo)) {
        setAuthInfo(currentAuthInfo)
      }
      if (JSON.stringify(currentUserInfo) !== JSON.stringify(userInfo)) {
        setUserInfo(currentUserInfo)
      }
    }, 1000)

    return () => {
      window.removeEventListener('storage', handleStorageChange)
      clearInterval(interval)
    }
  }, [authInfo, userInfo])

  const fetchData = async () => {
    try {
      const currentAuthInfo = JSON.parse(localStorage.getItem("authInfo"))
      if (currentAuthInfo) {
        const authorId = currentAuthInfo.id || null
        const res = await axios.get(`/user/get-common-service/${id}`, {
          params: {
            authorId: authorId,
          },
        })
        const data = res.data.data
        sessionStorage.setItem("serviceDetails", JSON.stringify(data))
        const dataArray = Array.isArray(res.data.data) ? res.data.data : [res.data.data]
        setCommonServiceData(dataArray)
        setDescription(dataArray[0].result.description)
        setCategory(dataArray[0].result.category.categoryName)
        setReviews(dataArray[0].result.reviews)
        setServiceCreator(dataArray[0].result.createdBy.email)
        setSellerId(dataArray[0].result.createdBy.id)
        setChargesPayStatus(dataArray[0].chargePay)
        setLoading(false)
      } else {
        const res = await axios.get(`/user/get-common-service/${id}`)
        const data = res.data.data
        sessionStorage.setItem("serviceDetails", JSON.stringify(data))
        const dataArray = Array.isArray(res.data.data) ? res.data.data : [res.data.data]
        setCommonServiceData(dataArray)
        setDescription(dataArray[0].result.description)
        setCategory(dataArray[0].result.category.categoryName)
        setReviews(dataArray[0].result.reviews)
        setServiceCreator(dataArray[0].result.createdBy.email)
        setSellerId(dataArray[0].result.createdBy.id)
        setLoading(false)
      }
    } catch (error) {
      console.log(error)
      setLoading(false)
    }
  }

  const scrollToMyRef = (event) => {
    event.preventDefault()
    myRef.current.scrollIntoView({ behavior: "smooth" })
    setScrollToReviews(true)
    setScheduledMeeting(false)
  }

  const setMeeting = (event) => {
    event.preventDefault()
    myRef.current.scrollIntoView({ behavior: "smooth" })
    setScheduledMeeting(true)
    setScrollToReviews(false)
  }

  const fetchApi = async () => {
    try {
      const response = await axios.get(`/user/get-service-review/${serviceId}`)
      const result = response.data.data
      setReviews(result)
      if (result.length > 0) {
        const totalRating = result.reduce((acc, curr) => acc + curr.rating, 0)
        const average = totalRating / result.length
        setAverageRating(average)
        setTotalReview(result.length)
      }
    } catch (error) {
      console.log("Error fetching data:", error)
    }
  }

  // Updated handleSupportChat function
  const handleSupportChat = async () => {
    if (!checkLoginOrShowModal()) return;

    // Get fresh auth info from localStorage
    const currentAuthInfo = JSON.parse(localStorage.getItem("authInfo"));
    const currentUserInfo = JSON.parse(localStorage.getItem("userInfo"));

    console.log("Current auth info:", currentAuthInfo);
    console.log("Current user info:", currentUserInfo);

    if (!currentAuthInfo || !currentUserInfo) {
      toast.error("Please login to proceed.");
      setShowLoginModal(true);
      return;
    }

    try {
      const response = await axios.post(
        "/user/accessChat",
        {
          receiverId: {
            id: sellerId,
            name: commonServiceData[0]?.result.createdBy.name,
            image_url: commonServiceData[0]?.result.createdBy.image_url || "",
            role: "Seller",
          },
          authorId: {
            id: currentAuthInfo.id,
            name: currentUserInfo.name,
            image_url: currentUserInfo.imgUrl || "",
            role: "User",
          },
        },
        {
          headers: {
            Authorization: `Bearer ${currentAuthInfo.token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.status === true) {
        history.push({
          pathname: `/chat`,
          state: {
            targetUserId: sellerId,
            serviceId,
            serviceName: commonServiceData[0]?.result?.name,
            charges: commonServiceData[0]?.result?.charges,
            description,
            serviceCreator,
            chargesPayStatus,
            sellerId,
            autoSelectChat: true,
          },
        });
      } else {
        toast.error("Failed to initiate chat.");
      }
    } catch (error) {
      console.error("Chat error:", error);
      toast.error("Unable to start chat.");
    }
  };

  const checkLoginOrShowModal = () => {
    // Always get fresh data from localStorage
    const currentAuthInfo = JSON.parse(localStorage.getItem("authInfo"));
    const currentUserInfo = JSON.parse(localStorage.getItem("userInfo"));

    if (!currentAuthInfo || !currentUserInfo || !currentAuthInfo.id) {
      toast.error("Please login to proceed.");
      sessionStorage.setItem("redirectTo", window.location.pathname);
      setShowLoginModal(true);
      return false;
    }
    return true;
  };

  const handleBookModal = async () => {
    if (!checkLoginOrShowModal()) return;
    setShowOrderPopup(true);
  }

  const quoteRequestRef = useRef(null)

  const handleQuoteClick = () => {
    if (!checkLoginOrShowModal()) return
    quoteRequestRef.current?.open()
  }

  // Add handler for when login modal closes successfully
  const handleLoginSuccess = () => {
    setShowLoginModal(false);
    // Update auth info immediately after successful login
    const newAuthInfo = JSON.parse(localStorage.getItem("authInfo"));
    const newUserInfo = JSON.parse(localStorage.getItem("userInfo"));
    setAuthInfo(newAuthInfo);
    setUserInfo(newUserInfo);

    // Optionally refetch data if needed
    fetchData();
  };

  return (
    <React.Fragment>
      {loading === true ? <SpinnerLoader /> : ""}

      {showLoginModal && (
        <LoginModal
          onloginHide={handleLoginSuccess} // Use the success handler
          onregisterShow={() => {}}
          onForgotShow={() => {}}
        />
      )}

      <BannerTopIframe keywords={category} />
      <Header />
      <PageTitle title={"Service-Details"} />
      <section className="inr_wrap">
        <div className="container">
          {commonServiceData.length > 0 &&
            commonServiceData.map((data, index) => (
              <div className="row g-0 bg-white p-5 rounded" key={index}>
                <Helmet>
                  <title>{`Service-detail/${data.result.serviceCode} - Pay Earth`}</title>
                </Helmet>
                <div className="d-flex justify-content-end">
                  <div className="">
                    <button
                      type="button"
                      className="btn custum_back_btn btn_yellow mt-3 mx-3"
                      onClick={() => window.history.back()}
                    >
                      <img src={arrow_back || "/placeholder.svg"} alt="back" />
                      &nbsp; Back
                    </button>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="prod_dtl_info">
                    <div className="prod_dtl_body">
                      <Badge>{data.result.category.categoryName}</Badge>
                      <h2>{data.result.name}</h2>
                      <UserReviewSummary
                        image={commonServiceData[0]?.result?.createdBy?.image_url}
                        name={commonServiceData[0]?.result?.createdBy?.name}
                        rating={averageRating}
                        scrollToMyRef={scrollToMyRef}
                      />
                      <div className="py-3">
                        {/* Description is saved from ReactQuill (HTML). Render it as HTML. */}
                        <div
                          className="service-description"
                          dangerouslySetInnerHTML={{
                            __html: data?.result?.description || "",
                          }}
                        />
                      </div>
                      <div className="">
                        <p
                          style={{
                            fontWeight: 600,
                            fontSize: "20px",
                          }}
                        >
                          Starts from ${data.result.charges}
                        </p>
                        <p>Fast Delivery</p>
                      </div>

                      <div className="flex my-2">
                        <button
                          type="button"
                          className="btn custum_back_btn btn_yellow mt-3 mx-3"
                          onClick={handleBookModal}
                        >
                          Book a Service
                        </button>

                        <button
                          type="button"
                          className="btn custom_btn message_btn mt-3 mx-3"
                          onClick={handleSupportChat}
                        >
                          Message Seller
                        </button>

                        <button
                          type="button"
                          className="btn custum_back_btn btn_yellow mt-3 mx-3"
                          onClick={handleQuoteClick}
                        >
                          Request Quote
                        </button>

                        <QuoteRequestButton
                          ref={quoteRequestRef}
                          serviceId={data.result.id}
                          sellerId={sellerId}
                          itemName={data.result.name}
                          itemImage={data.result.featuredImage}
                          itemPrice={data.result.charges}
                        />
                      </div>

                      <div className="pdi_share_links"></div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="ser_thumb_div">
                    <img
                      className="img_srv_details"
                      src={data.result.featuredImage || "/placeholder.svg"}
                      alt="Service Details Image"
                    />
                  </div>
                </div>
              </div>
            ))}
          <HowItWorks />
        </div>
      </section>
      <div name="myRef" ref={myRef}>
        <ServiceDetailsTabbing
          showOrderPopup={showOrderPopup}
          onHide={() => setShowOrderPopup(false)}
          serviceId={id}
          serviceName={commonServiceData[0]?.result.name}
          description={description}
          scrollToReviews={scrollToReviews}
          scheduledMeeting={scheduledMeeting}
          serviceCreator={serviceCreator}
          sellerId={sellerId}
          chargesPayStatus={chargesPayStatus}
          charges={commonServiceData[0]?.result?.charges}
          sellerData={commonServiceData[0]?.result?.createdBy}
        />
      </div>
      <Footer />
      <GoToTop />
    </React.Fragment>
  )
}

const renderStars = (rating) => {
  const fullStars = Math.floor(rating)
  const halfStar = rating % 1 >= 0.5
  const emptyStars = 5 - fullStars - (halfStar ? 1 : 0)

  return (
    <>
      {[...Array(fullStars)].map((_, i) => (
        <FaStar key={`full-${i}`} color="#f1c40f" />
      ))}
      {halfStar && <FaStarHalfAlt color="#f1c40f" />}
      {[...Array(emptyStars)].map((_, i) => (
        <FaRegStar key={`empty-${i}`} color="#f1c40f" />
      ))}
    </>
  )
}

const UserReviewSummary = ({ image, name, rating, totalReviews, scrollToMyRef }) => {
  return (
    <div className="d-flex align-items-center gap-2">
      <Image src={image || "/placeholder.svg"} alt={name} roundedCircle width={40} height={40} className="me-2" />
      <div>
        <div style={{ fontWeight: "600" }}>{name}</div>
        <div className="d-flex align-items-center" style={{ fontSize: "14px", color: "#555" }}>
          {renderStars(rating)}
          <span className="ms-2">({rating.toFixed(1)} stars)</span>
          <span
            className="ms-2 text-muted"
            style={{
              textDecoration: "underline",
              cursor: "pointer",
            }}
            onClick={scrollToMyRef}
          >
            {totalReviews} reviews
          </span>
        </div>
      </div>
    </div>
  )
}

const HowItWorks = () => {
  const steps = [
    {
      title: "Place Order",
      icon: <FaClipboardCheck size={24} />,
      description: "Choose a service and complete the checkout.",
    },
    {
      title: "Initial Contact",
      icon: <FaPhoneAlt size={24} />,
      description: "We reach out to confirm requirements and set milestones.",
    },
    {
      title: "Milestone Progress",
      icon: <FaCogs size={24} />,
      description: "Track real-time progress for each service milestone.",
    },
    {
      title: "Delivery & Feedback",
      icon: <FaShippingFast size={24} />,
      description: "Receive your service and provide feedback or approval.",
    },
  ]
  return (
    <Container className="my-5 bg-white rounded-2 p-5">
      <h2 className="mb-4">How It Works</h2>
      <Row className="g-4">
        {steps.map((step, index) => (
          <Col md={6} lg={3} key={index}>
            <Card className="h-100 text-center shadow-sm border-0" style={{ padding: "20px" }}>
              <div className="text-primary mb-3">{step.icon}</div>
              <Card.Title className="fw-bold">{step.title}</Card.Title>
              <Card.Text className="text-muted">{step.description}</Card.Text>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  )
}

export default ServiceDetails
